import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import '@/shared/consts/events.quiz-plan-change';
import { trackEvent } from '@zep/logger/tracking';
import { type PlanManagementCtaPlace } from '@/shared/consts/events.quiz-plan-change';
import { openOverlayOnceAsync } from '@/shared/utils/openOverlayOnce';
import { Button, DialogBody, DialogFooter, DialogHeader, ResponsiveDialog } from '@/ui_v3';
const overlayId = 'planChangeInquiryAlert';
export type PlanChangeInquiryAlertTrackingContext = {
  place: 'plan_change_checkout' | PlanManagementCtaPlace;
  change_type: 'upgrade';
  blocked_reason: string;
};

/**
 * 반드시 `common` 네임스페이스를 쓴다. 이 모달은 업셀링 모달·플랜 관리 등 어디서든
 * 열리는데, `billing` 은 `/profile/plan` 과 `/checkout*` 에서만 로드된다
 * (`currentExtensionBlock.ts` 의 EXTENSION_BLOCKED_COPY 와 같은 이유).
 */
const PlanChangeInquiryAlert = ({
  onClose,
  trackingContext
}: {
  onClose: (confirmed: boolean) => void;
  trackingContext?: PlanChangeInquiryAlertTrackingContext;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const select = (decision: 'close' | 'contact') => {
    if (trackingContext) {
      trackEvent('quiz_plan_change_inquiry_alert_select', {
        ...trackingContext,
        decision,
        destination: decision === 'contact' ? 'external_inquiry' : 'previous_surface'
      });
    }
    onClose(decision === 'contact');
  };
  return <ResponsiveDialog size="xs" onClose={() => select('close')} data-sentry-element="ResponsiveDialog" data-sentry-component="PlanChangeInquiryAlert" data-sentry-source-file="planChangeInquiryAlert.tsx">
      <DialogHeader title={t('common:planManage.changeInquiry.title')} className="!px-lg !pb-xs !pt-lg" data-sentry-element="DialogHeader" data-sentry-source-file="planChangeInquiryAlert.tsx" />
      <DialogBody className="h-auto px-lg pb-none" data-sentry-element="DialogBody" data-sentry-source-file="planChangeInquiryAlert.tsx">
        <p className="whitespace-pre-line text-body-md-regular text-default">
          {t('common:planManage.changeInquiry.description')}
        </p>
      </DialogBody>
      <DialogFooter className="flex flex-col gap-xs !px-lg !py-lg" data-sentry-element="DialogFooter" data-sentry-source-file="planChangeInquiryAlert.tsx">
        <Button variant="contained" intent="alternative" size="md" className="w-full" onClick={() => select('contact')} data-sentry-element="Button" data-sentry-source-file="planChangeInquiryAlert.tsx">
          {t('common:play.header.inquiry')}
        </Button>
        <Button variant="transparent" intent="neutral" size="xs" className="w-full" onClick={() => select('close')} data-sentry-element="Button" data-sentry-source-file="planChangeInquiryAlert.tsx">
          {t('common:global.close.button')}
        </Button>
      </DialogFooter>
    </ResponsiveDialog>;
};
export const openPlanChangeInquiryAlert = async (onContact: () => void, trackingContext?: PlanChangeInquiryAlertTrackingContext) => {
  const shouldContact = await openOverlayOnceAsync<boolean>(overlayId, ({
    close
  }) => <PlanChangeInquiryAlert onClose={close} trackingContext={trackingContext} />);
  overlay.unmount(overlayId);
  if (shouldContact) onContact();
};